/* @begin tools\lib\annotation\resource\Parser {
	"id": {
		"type": "js",
		"name": "aptis.UUIDGenerator",
		"precedence": 1
	}
} @end tools\lib\annotation\resource\Parser */

var aptis = aptis || {};

aptis.UUIDGenerator = new Class({

	/**
	 * @return {String}
	 */
	generate: function() {
		var time = new Date().getTime();
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (time + Math.random() * 16) % 16 | 0;
			time = Math.floor(time / 16);
			return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	}
});
